import React, { useEffect, useState } from "react";
import { Button, TextField, Box, Snackbar } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import { writeTransactionFromWallet } from "kalp-wallet-dapp-pkg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import Gateways from "ks-pay-package-pvt";

const Payment = ({ goBack, merchantId }) => {
  // Add goBack prop
  const [modalShow, setModalShow] = useState(false);
  const [amount, setamount] = useState("");
  const [token, setToken] = useState("");
  const [currency, setCurrency] = useState("");
  const [sign, setSign] = useState("");
  const [gateway, setGatewayDetails] = useState(null);
  const [address, setAddress] = useState("");
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");

  useEffect(() => {
    genToken();
  }, []);

  useEffect(() => {
    if (token.length > 0) {
      getCurrency();
    }
  }, [token]);

  const handleGini = async () => {};

  const makePayment = async () => {};

  useEffect(() => {
    if (sign.length > 0) {
      processOrder();
    }
  }, [sign]);

  const genToken = async () => {
    try {
      let res = await axios.post(
        `${process.env.React_App_PAYMENT_URL}auth/generate-token/${process.env.REACT_APP_APP_ID}`,
        {
          accessKey: process.env.REACT_APP_PUBLIC_KEY,
          secretKey: process.env.REACT_APP_PRIVATE_KEY,
        }
      );

      setToken(res?.data?.result?.accessToken);
      localStorage.setItem("token", res?.data?.result?.accessToken);
    } catch (error) {
      console.log({ error });
    }
  };
  function generateRandomString(length = 16) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    const array = new Uint32Array(length);
    crypto.getRandomValues(array);

    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters[array[i] % charactersLength];
    }

    return result;
  }

  const checkData = () => {
    if (!/^[0-9a-fA-F]{40}$/.test(address)) {
      setMessage("Invalid Wallet address");
      setOpen(true);
      return true;
    } else if (!Number.isInteger(Number(amount))) {
      setMessage("Invalid amount");
      setOpen(true);
      return true;
    }
    return false;
  };
  const intiateOrder = async () => {
    if (checkData()) {
      return;
    }

    let payload = {
      currencyId: currency,
      // paymentMethodId:'All',
      amount: parseInt(amount),
      referenceNumber: generateRandomString(),
      appId: process.env.REACT_APP_APP_ID,
      redirectUrl: `${window.location.origin}/success`,
      meta: { walletAddress: address },
    };
    try {
      let res = await axios.post(
        `${process.env.React_App_PAYMENT_URL}transaction/initiate`,
        payload,
        {
          headers: {
            accessKey: process.env.REACT_APP_PUBLIC_KEY,
            secretKey: process.env.REACT_APP_PRIVATE_KEY,
          },
        }
      );

      setSign(res?.data?.result);
    } catch (error) {
      console.log({ error });
    }
  };

  const processOrder = async () => {
    let headers = {
      "x-signature": sign,
    };
    try {
      let res = await axios.post(
        `${process.env.React_App_PAYMENT_URL}transaction/process`,
        {},
        { headers }
      );

      setGatewayDetails(res?.data?.result);
    } catch (e) {
      console.log(e);
    }
  };

  const getCurrency = async () => {
    let headers = {
      Authorization: token,
    };
    try {
      let res = await axios.get(
        `${process.env.React_App_PAYMENT_URL}currencies`,
        {
          headers: {
            // your headers go here
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        }
      );
      setCurrency(res?.data?.result[0]?.id);
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        padding: "20px",
      }}
    >
      {/* Back Button */}
      <Button
        onClick={goBack} // Call goBack on click
        startIcon={<ArrowBackIcon />}
        sx={{
          alignSelf: "flex-start",
          marginBottom: "20px",
          textTransform: "none",
        }}
      >
        Back
      </Button>
      <input
        className="input-wallet"
        type="text"
        placeholder="Enter Wallet Address"
        style={{ padding: "3.5px 14px", marginBottom: "1rem" }}
        onChange={(e) => {
          setAddress(e?.target?.value);
        }}
      />
      <input
        className="input-amount"
        type="number"
        placeholder="Enter Amount"
        style={{ padding: "3.5px 14px", marginBottom: "1rem" }}
        onChange={(e) => {
          setamount(e?.target?.value);
        }}
      />

      {/* Whitelist User Button */}
      <Button
        variant="contained"
        onClick={intiateOrder}
        disabled={amount.length == 0 || address.length !== 40}
        sx={{
          marginBottom: "10px",
          backgroundColor: "#0055FF",
          borderRadius: "8px",
          height: "45px",
          width: "100%", // Ensures button width matches TextField
          maxWidth: "400px",
          textTransform: "none",
          fontSize: "16px",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "#0044CC",
          },
        }}
      >
        Recharge
      </Button>
      {gateway && Object.keys(gateway).length != 0 && (
        <Gateways payload={gateway} />
      )}
      <Snackbar
        open={open}
        onClose={() => setOpen(false)}
        autoHideDuration={3000}
        message={message}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />
    </Box>
  );
};

export default Payment;
